var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"progress-bar-wrapper"},[_c('div',{staticClass:"progress-bar overflow-hidden h-1 mb-4 text-xs flex rounded bg-blue-500"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }